import { createSlice } from "@reduxjs/toolkit";

interface AuthState {
  loading: boolean;
  user: any | null;
  token: string | null;
  error: any | null;
}

const initialState: AuthState = {
  loading: true,
  user: null,
  token: null,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.loading = false;
    },
    loginFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    tokenAcquisitionStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    tokenAcquisitionSuccess: (state, action) => {
      // Update both the standalone token and the user's idToken
      state.token = action.payload;
      if (state.user) {
        // For string tokens, update idToken directly
        if (typeof action.payload === "string") {
          state.user.idToken = action.payload;
        } 
        // For token objects, extract the accessToken
        else if (action.payload && action.payload.accessToken) {
          state.user.idToken = action.payload.accessToken;
        }
      }
      state.loading = false;
    },
    tokenAcquisitionFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    // For token refresh after re-authentication
    updateToken: (state, action) => {
      if (state.user) {
        state.user.idToken = action.payload;
      }
      state.token = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.loading = false;
      state.error = null;
    },
    logoutError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  tokenAcquisitionStart,
  tokenAcquisitionSuccess,
  tokenAcquisitionFailure,
  updateToken,
  logout,
  logoutError,
} = authSlice.actions;
export default authSlice.reducer;
